/* ============================================================
   OJAS — behaviour.
   No dependencies. Everything degrades to a working page.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Treat metered/slow connections like reduced motion for the loader. */
  var conn = navigator.connection || {};
  var thin = conn.saveData === true || /2g/.test(conn.effectiveType || '');

  /* ----------------------------------------------------------
     1. VEIL
     A brand loader has to earn its milliseconds. This one is
     capped hard, dismissed as soon as the hero image is ready,
     shown once per session, and skipped outright for anyone who
     asked for less motion or is on a thin connection.
     ---------------------------------------------------------- */
  var veil = doc.getElementById('veil');
  var CAP = 900; /* absolute ceiling, ms */

  function dropVeil() {
    if (!veil || veil.classList.contains('veil--gone')) return;
    veil.classList.add('veil--gone');
    try { sessionStorage.setItem('ojas:seen', '1'); } catch (e) {}
    window.setTimeout(function () { if (veil) veil.remove(); }, 600);
  }

  var seen = false;
  try { seen = sessionStorage.getItem('ojas:seen') === '1'; } catch (e) {}

  if (!veil) {
    /* nothing to do */
  } else if (reduced || thin || seen) {
    veil.remove();
    veil = null;
  } else {
    var start = Date.now();
    var out = doc.getElementById('veilCount');

    var tick = window.setInterval(function () {
      var pct = Math.min(99, Math.round((Date.now() - start) / CAP * 100));
      if (out) out.textContent = pct < 10 ? '0' + pct : String(pct);
      if (pct >= 99) window.clearInterval(tick);
    }, 40);

    var finish = function () {
      window.clearInterval(tick);
      if (out) out.textContent = '100';
      dropVeil();
    };

    var hero = doc.querySelector('.hero__media img');
    if (hero && hero.complete) {
      window.setTimeout(finish, 420);           /* cached: just a beat */
    } else if (hero) {
      hero.addEventListener('load', function () {
        var spent = Date.now() - start;
        window.setTimeout(finish, Math.max(0, 420 - spent));
      }, { once: true });
      hero.addEventListener('error', finish, { once: true });
    }
    window.setTimeout(finish, CAP);              /* never longer than this */
  }

  /* ----------------------------------------------------------
     2. REVEAL ON SCROLL
     ---------------------------------------------------------- */
  var reveals = [].slice.call(doc.querySelectorAll('.reveal'));

  if (reduced || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('reveal--in'); });
  } else {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('reveal--in');
        ro.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });

    reveals.forEach(function (el, i) {
      /* a short stagger between siblings, capped so nothing feels slow */
      var prev = el.previousElementSibling;
      if (prev && prev.classList.contains('reveal')) {
        el.style.transitionDelay = Math.min(i % 3, 2) * 45 + 'ms';
      }
      ro.observe(el);
    });
  }

  /* ----------------------------------------------------------
     3. HERO HEADLINE — line-by-line rise
     ---------------------------------------------------------- */
  if (!reduced) {
    [].slice.call(doc.querySelectorAll('.hero__title .r')).forEach(function (line, i) {
      var inner = doc.createElement('span');
      inner.textContent = line.textContent;
      line.textContent = '';
      line.appendChild(inner);
      inner.style.transform = 'translateY(105%)';
      inner.style.transition = 'transform .95s cubic-bezier(.22,.61,.36,1) ' +
                               (260 + i * 110) + 'ms';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { inner.style.transform = 'translateY(0)'; });
      });
    });
  }

  /* ----------------------------------------------------------
     4. HEADER STATE + SCROLL METER ("the reserve")
     ---------------------------------------------------------- */
  var hdr = doc.getElementById('hdr');
  var meterFill = doc.querySelector('.meter i');
  var bar = doc.getElementById('bar');
  var heroEl = doc.querySelector('.hero');
  var lastY = 0;
  var queued = false;

  function onScroll() {
    var y = window.pageYOffset || doc.documentElement.scrollTop;
    var heroH = heroEl ? heroEl.offsetHeight : window.innerHeight;

    if (hdr) {
      hdr.classList.toggle('hdr--solid', y > heroH - 90);
      /* hide on downward scroll once past the hero, show on the way back up */
      hdr.classList.toggle('hdr--up', y > heroH && y > lastY + 4);
    }

    if (meterFill) {
      var max = doc.documentElement.scrollHeight - window.innerHeight;
      meterFill.style.width = (max > 0 ? (y / max) * 100 : 0) + '%';
    }

    if (bar) {
      if (y > heroH * 0.9) {
        bar.hidden = false;
        requestAnimationFrame(function () { bar.classList.add('bar--in'); });
      } else {
        bar.classList.remove('bar--in');
      }
    }

    lastY = y;
    queued = false;
  }

  window.addEventListener('scroll', function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(onScroll);
  }, { passive: true });
  onScroll();

  /* ----------------------------------------------------------
     5. SECTION-AWARE DOCUMENT TITLE
     The tab tells you where you are in the page.
     ---------------------------------------------------------- */
  var titled = [].slice.call(doc.querySelectorAll('[data-title]'));
  var base = doc.title;

  if ('IntersectionObserver' in window && titled.length) {
    var to = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) doc.title = en.target.getAttribute('data-title') || base;
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    titled.forEach(function (s) { to.observe(s); });
  }

  /* ----------------------------------------------------------
     6. PRICE — one-time is and stays the default
     ---------------------------------------------------------- */
  var PRICES = { onetime: 28.00, sub: 25.20 };
  var priceOut = doc.getElementById('priceOut');
  var barPrice = doc.getElementById('barPrice');
  var form = doc.getElementById('buyForm');

  function money(n) { return '$' + n.toFixed(2); }

  function syncPrice() {
    var picked = doc.querySelector('input[name="plan"]:checked');
    var val = PRICES[picked ? picked.value : 'onetime'];
    if (priceOut) priceOut.textContent = money(val);
    if (barPrice) barPrice.textContent = money(val);
  }

  [].slice.call(doc.querySelectorAll('input[name="plan"]')).forEach(function (r) {
    r.addEventListener('change', syncPrice);
  });
  syncPrice();

  if (form) {
    form.addEventListener('submit', function (e) {
      /* Shopify's /cart/add takes over here. */
      e.preventDefault();
      var picked = doc.querySelector('input[name="plan"]:checked');
      var btn = form.querySelector('button[type="submit"] span');
      if (btn) {
        var was = btn.innerHTML;
        btn.textContent = 'Added — ' + (picked && picked.value === 'sub'
          ? 'every 30 days' : 'one-time');
        window.setTimeout(function () { btn.innerHTML = was; syncPrice(); }, 1900);
      }
    });
  }

  /* ----------------------------------------------------------
     7. LETTER ROLL on plain-text CTAs
     ---------------------------------------------------------- */
  if (!reduced) {
    [].slice.call(doc.querySelectorAll('[data-roll]')).forEach(function (btn) {
      var span = btn.querySelector('span');
      if (!span || span.childElementCount > 0) return;   /* skip dynamic labels */
      var text = span.textContent;
      span.textContent = '';
      text.split('').forEach(function (ch, i) {
        var s = doc.createElement('span');
        s.className = 'roll';
        var inner = doc.createElement('i');
        inner.textContent = ch === ' ' ? ' ' : ch;
        inner.setAttribute('data-c', ch === ' ' ? ' ' : ch);
        inner.style.transitionDelay = (i * 14) + 'ms';
        s.appendChild(inner);
        span.appendChild(s);
      });
      span.setAttribute('aria-label', text);
    });
  }
  /* ----------------------------------------------------------
     8. IN-PAGE ANCHOR SCROLLING
     The header "Buy · $28" link is a plain <a href="#buy">, which
     relies on the browser honouring scroll-behavior + scroll-padding-top.
     Where that is unsupported or suppressed the click looks like it does
     nothing. This makes the scroll explicit and offsets by the real
     measured height of the fixed header instead of a hard-coded value.
     ---------------------------------------------------------- */
  function headerOffset() {
    var h = doc.querySelector('.hdr');
    return (h ? h.getBoundingClientRect().height : 60) + 16;
  }

  doc.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey ||
        e.shiftKey || e.altKey) return;

    var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;

    var href = a.getAttribute('href');
    if (!href || href === '#') return;

    var target = doc.getElementById(href.slice(1));
    if (!target) return;

    e.preventDefault();

    var top = target.getBoundingClientRect().top + (window.pageYOffset ||
              doc.documentElement.scrollTop) - headerOffset();
    if (top < 0) top = 0;

    try {
      window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
    } catch (err) {
      window.scrollTo(0, top);                      /* older browsers */
    }

    if (window.history && history.replaceState) history.replaceState(null, '', href);

    /* move focus so keyboard and screen-reader users follow the jump too */
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
  });

  /* ----------------------------------------------------------
     9. HERO PHOTOGRAPH — never leave the caption stranded
     "Fig. 01 — Hand harvest..." describes the full-bleed hero photo.
     If that photo fails (empty src, 404, decode error) the caption
     must go with it rather than sitting above an empty gap.
     ---------------------------------------------------------- */
  (function () {
    var img = doc.querySelector('.hero__media img');
    var cap = doc.querySelector('.hero__fig');
    var media = doc.querySelector('.hero__media');
    if (!img) { if (cap) cap.hidden = true; return; }

    function failed() {
      if (cap) cap.hidden = true;
      if (media) media.classList.add('hero__media--failed');
    }

    var src = img.getAttribute('src');
    if (!src && !img.getAttribute('srcset')) { failed(); return; }

    img.addEventListener('error', failed, { once: true });
    if (img.complete && img.naturalWidth === 0) failed();
  })();

  /* ----------------------------------------------------------
     10. PRODUCT GALLERY — click a thumbnail, swap the stage image.
     Pure CSS handles the visual state (.is-active); this just
     keeps stage and thumbs in sync on click.
     ---------------------------------------------------------- */
  (function () {
    var thumbs = [].slice.call(doc.querySelectorAll('[data-gal-thumb]'));
    if (!thumbs.length) return;
    var imgs = [].slice.call(doc.querySelectorAll('[data-gal-img]'));

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = t.getAttribute('data-gal-thumb');
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        imgs.forEach(function (im) {
          im.classList.toggle('is-active', im.getAttribute('data-gal-img') === idx);
        });
      });
    });
  })();
})();
